<template>
  <div>
    <div
      v-if="!isEmpty"
      style="display: grid;gap: 10px;"
      :style="{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }"
    >
      <Item
        v-for="item in _items"
        :key="item.id || item.fileName"
        :file="item"
        :disabled="disabled"
        :layout="layout"
        @delete="handleDelete"
      ></Item>
    </div>

    <div v-if="isEmpty">
      <slot name="empty">
        <div v-if="empty" style="  text-align: center;">
          <p style="font-size: 14px; color: #6C757D;margin-top: 10px;">
            {{ '暂无文档' }}
          </p>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { request } from '@/api/service'
import Item from './file-item.vue'

export default {
  name: 'FileList',
  components: {
    Item,
  },
  props: {
    items: { type: Array, default: () => [] },
    empty: { type: Boolean, default: true },
    disabled: { type: Boolean, default: true },
    layout: {
      type: Object,
      default: () => ({}),
    },
    cols: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      fileIcons: {},
    }
  },
  computed: {
    _items() {
      if (this.isEmpty) {
        return []
      }

      return this.items.map((t) => ({
        ...t,
        fileIcon: this.loadFileIcon(t.fileName),
      }))
    },
    isEmpty() {
      return !this.items?.length
    },
  },
  mounted() {
    this.loadFileIcons()
  },
  methods: {
    async loadFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    loadFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
    },
    handleDelete(file) {
      this.$emit('delete', file)
    },
  },
}
</script>
